import * as React from 'react';
var EMPTY_CELL = React.createElement("div", { className: "k-scheduler-cell k-side-cell" });
/** @hidden */
export var TimelineViewRowContent = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "k-sticky-cell" }, EMPTY_CELL),
        props.children));
};
//# sourceMappingURL=TimelineViewRowContent.js.map